/* Shared focus trap for the theme's modal surfaces (cart drawer, search overlay,
   guarantee/subscription drawers).

   Without this, Tab from inside an open drawer walks into the page behind it: keyboard and
   screen-reader users end up operating controls they can't see, with no way back. This also
   restores focus to whatever opened the drawer on close, which is what makes the pattern
   usable rather than merely compliant.

   Usage:
     var release = VPFocusTrap.trap(element);   // call when opening
     release();                                 // call when closing

   Safe to call repeatedly; trapping an already-trapped element is a no-op. */
(function (w) {
  'use strict';

  var SELECTOR = [
    'a[href]', 'button:not([disabled])', 'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])', 'textarea:not([disabled])', 'summary',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  function focusable(root) {
    return Array.prototype.slice.call(root.querySelectorAll(SELECTOR)).filter(function (el) {
      // offsetParent is null for display:none; also skip anything inside a hidden subtree.
      return el.offsetParent !== null || el === document.activeElement;
    });
  }

  function trap(root) {
    if (!root || root.__vpTrapped) return function () {};
    root.__vpTrapped = true;
    var restoreTo = document.activeElement;

    function onKey(e) {
      if (e.key !== 'Tab') return;
      var items = focusable(root);
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    // If focus escapes (browser quirks, injected content), pull it back inside.
    function onFocusIn(e) {
      if (root.contains(e.target)) return;
      var items = focusable(root);
      if (items.length) items[0].focus();
    }

    document.addEventListener('keydown', onKey, true);
    document.addEventListener('focusin', onFocusIn, true);

    return function release() {
      document.removeEventListener('keydown', onKey, true);
      document.removeEventListener('focusin', onFocusIn, true);
      root.__vpTrapped = false;
      if (restoreTo && typeof restoreTo.focus === 'function' && document.contains(restoreTo)) {
        restoreTo.focus();
      }
    };
  }

  w.VPFocusTrap = { trap: trap, focusable: focusable };
})(window);
